// Globals
import { useTranslation } from 'react-i18next';

// Models
import { IRobotsData } from '@/models/seo.model';

// Components
import { TextArea, Skeleton } from '@/ui';
import { FormItem, IFormInstance } from '@/components';
import { StyledForm } from './UpdateRobotsFormStyles';

// Helpers
import { RobotsFormFieldsNames } from '../../helpers';
import { useRobotsFormRules } from '../../hooks';

interface IUpdateRobotsFormProps {
  handleSubmit: () => void;
  isLoading: boolean;
  formInstance: IFormInstance;
  initialValues?: IRobotsData | null;
}

const UpdateRobotsForm = ({ handleSubmit, isLoading, initialValues, formInstance }: IUpdateRobotsFormProps) => {
  const { t } = useTranslation(['seo']);
  const rules = useRobotsFormRules();

  const placeholder = t('common_placeholder_input', { ns: 'common' });

  if (isLoading) return <Skeleton />;

  return (
    <StyledForm onFinish={handleSubmit} form={formInstance} initialValues={initialValues ?? {}}>
      <FormItem
        name={RobotsFormFieldsNames.CONTENT}
        label={t('seo_robots_tab_title')}
        rules={rules[RobotsFormFieldsNames.CONTENT]}
      >
        <TextArea placeholder={placeholder} rows={5} />
      </FormItem>
    </StyledForm>
  );
};

export default UpdateRobotsForm;
